import { useGetIdentity } from 'react-admin';

import { isTroveInternalEmail } from './isTroveInternalEmail';

/**
 * Whether the signed-in user is a Trove employee (trove.co / trove.com email), for gating
 * "Trove only" features. This is a UI-visibility gate, not a security boundary — the data behind
 * these features is still served by reware-api to anyone with the underlying permission.
 *
 * Fails closed: while the identity is loading, or if it can't be read, `isTroveUser` is false.
 * Callers that would otherwise deny or redirect a Trove user (e.g. a deep link to a Trove-only
 * tab) must wait out `isPending` first.
 */
export const useIsTroveUser = () => {
  const { identity, isPending } = useGetIdentity();
  return { isTroveUser: isTroveInternalEmail(identity?.email), isPending };
};
